import { ELlmResponseType, LlmConversationNode } from '@adaptiva/ai/common';
import { inject, Injector, Pipe, PipeTransform, runInInjectionContext } from '@angular/core';
import { Observable } from 'rxjs';
import { getDashboardArtifactName } from './artifact-handlers';
import { LlmArtifactNameGenerator } from './types';

@Pipe({
	name: 'adaLlmArtifactName'
})
export class LlmArtifactNamePipe implements PipeTransform {

	protected readonly injector: Injector = inject(Injector);

	protected readonly mappings: Map<ELlmResponseType, LlmArtifactNameGenerator> = new Map([
		[ELlmResponseType.DASHBOARD, getDashboardArtifactName]
	]);

	public transform(_artifact: LlmConversationNode): Observable<string> {
		const _generator: LlmArtifactNameGenerator = this.mappings.get(_artifact.responseType);

		return runInInjectionContext(this.injector, () => _generator(_artifact));
	}

}
